function Spinner({ className = 'h-12 w-12' }: { className?: string }) {
  return (
    <svg className={`animate-spin ${className}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="&#194;&#169; v1 progress indicator (spinner)">
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.6126 21.4567C-0.60988 17.3764 -1.53584 9.83507 2.5444 4.6126C6.62465 -0.60988 14.166 -1.53584 19.3885 2.5444C24.6109 6.62465 25.5369 14.166 21.4567 19.3885C17.3764 24.6109 9.83507 25.5369 4.6126 21.4567ZM5.84392 19.8806C10.196 23.2808 16.4804 22.5092 19.8806 18.1571C23.2808 13.8051 22.5092 7.52063 18.1571 4.12043C13.8051 0.720222 7.52063 1.49186 4.12043 5.84392C0.720222 10.196 1.49186 16.4804 5.84392 19.8806Z"
          fill="#D9DCDE"
        />
        <path
          id="Path"
          d="M19.3885 2.5444C19.8237 2.88442 19.9008 3.51287 19.5608 3.94808C19.2208 4.38328 18.5924 4.46045 18.1571 4.12043C13.8051 0.720221 7.52063 1.49186 4.12043 5.84392C0.720221 10.196 1.49186 16.4804 5.84392 19.8806C10.196 23.2808 16.4804 22.5092 19.8806 18.1571C20.2207 17.7219 20.8491 17.6448 21.2843 17.9848C21.7195 18.3248 21.7967 18.9533 21.4567 19.3885C17.3764 24.6109 9.83507 25.5369 4.6126 21.4567C-0.60988 17.3764 -1.53584 9.83507 2.5444 4.6126C6.62465 -0.60988 14.166 -1.53584 19.3885 2.5444Z"
          fill="url(#paint0_linear_39723_33434)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_39723_33434"
          x1="8.76465"
          y1="-1.60444"
          x2="-1.58941"
          y2="15.3673"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00CA9D" />
          <stop offset="0.489583" stopColor="#006AE1" />
          <stop offset="1" stopColor="#8457D9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function Loader({
  className = 'h-96 w-full',
  spinnerClassName
}: {
  className?: string;
  spinnerClassName?: string;
}) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Spinner className={spinnerClassName} />
    </div>
  );
}
